// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OutsideClickHandler_wrapper__1zZu-"};